module.exports = __webpack_public_path__ + "img/声纹2.1856ab61.png";